import { cx } from "./cx";

/** An on/off switch (`.toggle`): a button with the switch role, so it is read as on or off. */
export function Toggle({ on, onChange, label, large = false, disabled = false, className }: {
  on: boolean;
  onChange: (on: boolean) => void;
  /** What it switches, read aloud: the switch alone shows only on or off. */
  label: string;
  large?: boolean;
  disabled?: boolean;
  className?: string;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      aria-label={label}
      disabled={disabled}
      className={cx("toggle", on && "on", large && "lg", className)}
      onClick={() => onChange(!on)}
    />
  );
}
